import React, { useState, useEffect } from 'react';
import { Row, Col, Button} from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Modal from '@material-ui/core/Modal';

const SurveyQuestionsModal = ({ opened, closeModal, questionData, Callback }) => {

    const [question, setQuestion] = useState(null);
    const [typeQuestion, setTypeQuestion] = useState(null);

    useEffect(() => {
        validateOpen();
    }, []);

    const validateOpen = () => {
        if(questionData != null && questionData != undefined)
        {
            setQuestion(questionData.item);
            setTypeQuestion(questionData.tipo);
        }
    }

    const saveSurveyQuestions = async () => {
        if (question != null && question != "" && typeQuestion != null && typeQuestion != "") {
            let dataSend = {
                item: question,
                tipo: typeQuestion
            }

            await fetch(`${process.env.REACT_APP_PUBLIC_URL}encuesta-item/create`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    Callback();
                    closeModal();
                    setQuestion(null);
                    setTypeQuestion(null);
                }
                else {
                    throw new Error('Ha ocurrido un error en el Servidor');
                }
            }).catch(err => {
                console.log(err);
            });
        }
        else {
            alert("La pregunta y el tipo de pregunta son obligatorios");
        }
    }

    const updateSurveyQuestions = async () => {
        if (question != null && question != "" && typeQuestion != null && typeQuestion != "") {
            let dataSend = {
                id_encuesta_item: questionData.id_encuesta_item,
                item: question,
                tipo: typeQuestion
            }

            await fetch(`${process.env.REACT_APP_PUBLIC_URL}encuesta-item/update`, {
                method: 'PUT',
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    Callback();
                    closeModal();
                    setQuestion(null);
                    setTypeQuestion(null);
                }
                else {
                    throw new Error('Ha ocurrido un error en el Servidor');
                }
            }).catch(err => {
                console.log(err);
            });
        }
        else {
            alert("La pregunta y el tipo de pregunta son obligatorios");
        }
    }

    return (
        <Modal
            open={opened}
            onClose={e => {
                closeModal();
            }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
        >
            <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                <div>
                    <div className="card__title">
                        <h5 className="bold-text">Item de Encuesta</h5>
                    </div>
                    <Row>
                        <Col md={9}>
                            <TextField
                                required
                                className="medical-material-form__field"
                                style={{ width: '100%' }}
                                id="names-standard-required"
                                label="Pregunta"
                                type="text"
                                value={question}
                                onChange={(e) => {
                                    setQuestion(e.target.value);
                                }}
                                InputLabelProps={{
                                    style: { color: '#646777' }
                                }}
                            />
                        </Col>
                        <Col md={3}>
                            <TextField
                                id="selectFormat"
                                label="Tipo"
                                select
                                value={typeQuestion}
                                className='medical-material-form__field'
                                onChange={(e) => {
                                    setTypeQuestion(e.target.value);
                                }}
                                style={{ minWidth: '100%' }}
                                InputLabelProps={{
                                    style: { color: '#646777' }
                                }}
                            >
                                <MenuItem key={1} value={1}>
                                    Pregunta de Satisfacción
                                </MenuItem>
                                <MenuItem key={2} value={2}>
                                    Recomendación
                                </MenuItem>
                            </TextField>
                        </Col>
                    </Row>
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        style={{ marginTop: 10 }}
                        variant="contained"
                        className="btn btn-secondary btn-sm"
                        onClick={() => {
                            closeModal();
                        }}
                    >
                        Cerrar
                    </Button>
                    <Button
                        style={{ marginTop: 10 }}
                        variant="contained"
                        className="btn btn-primary btn-sm text-white"
                        onClick={() => {
                            if (questionData != null && questionData != undefined) {
                                updateSurveyQuestions();
                            }
                            else {
                                saveSurveyQuestions();
                            }
                        }}
                    >
                        Guardar
                    </Button>
                </div>
            </div>
        </Modal>)
}

export default SurveyQuestionsModal;